export const getSubscriptionStatus = (allSubscriptionPayments) => {
  if (!allSubscriptionPayments?.length) return 'expiredDemo'

  const pendingPayments = allSubscriptionPayments?.filter((s) => s.paymentStatus === 'pending') // []
  const paidPayments = allSubscriptionPayments?.filter((s) => s.paymentStatus === 'paid') // []

  // Bloqueado por falta de pago:  2 o más cupones impagos
  if (pendingPayments.length >= 2) return 'blocked'

  // Bloqueado por baja: tiene todos los cupones pagos
  if (paidPayments.length === allSubscriptionPayments.length) return 'unsubscribed'

  // Bloqueado por demo vencida: No tiene cupones O tiene a lo sumo 1 impago
  if (pendingPayments.length <= 1) return 'expiredDemo'

  return 'unknown'
}
